/* Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
export const probeKey="cabinet-invite-probe";
export function consumeCabinetProbe(href:string,storage:Storage,replace:(url:string)=>void):string|undefined {
 const url=new URL(href),nonce=url.searchParams.get("cabinetCheck");
 if(!nonce)return;
 url.searchParams.delete("cabinetCheck");replace(url.href);
 const raw=storage.getItem(probeKey);storage.removeItem(probeKey);
 if(!raw)return;
 try {const probe=JSON.parse(raw),relative=url.pathname+url.search+url.hash;
  if(probe.nonce===nonce && probe.target===relative && probe.expires>Date.now())return relative;
 }catch { /* A malformed/foreign marker is never an authentication proof. */ }
}
export let confirmedGuestInvite:string|undefined;
try { confirmedGuestInvite=consumeCabinetProbe(window.location.href,sessionStorage,url=>window.history.replaceState(window.history.state,"",url)); }
catch { /* Embedded Safari contexts may deny storage; they do not consume probes. */ }
export async function checkCabinetInvite(relative:string,admin:string,signal:AbortSignal):Promise<void> {
 const response=await fetch("/api/auth/join-session/challenge",{method:"POST",credentials:"same-origin",signal});
 if(!response.ok)throw Error("Could not check cabinet session");
 const {challenge}=await response.json();if(!/^[A-Za-z0-9_-]{43}$/.test(challenge))throw Error("Invalid browser challenge");
 const nonce=crypto.randomUUID();sessionStorage.setItem(probeKey,JSON.stringify({nonce,target:relative,expires:Date.now()+90000}));
 const target=new URL("/auth/invite",admin);target.hash="?"+new URLSearchParams({target:relative,challenge,probe:nonce}).toString();
 if(!signal.aborted)window.location.replace(target.href);
}
